import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import { LockedAnchor } from ":src/components/overlays";
import { global } from ":shared/app";

export default function Schedule(props: _Navigation.SideNavJSXItemProps) {
  // const $settings = global.store.hooks.platform.useSettings("");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      // events={{
      //   getShouldNavigate: () => $settings()?.active,
      // }}
      triggers={
        {
          // onBeforeNavigate: () => {
          //   if (!$settings().active) {
          //     global.store.actions.alert.pushToast({
          //       type: "error",
          //       message: "This page is locked by admin, you can't access it right now!",
          //     });
          //   }
          // },
        }
      }
      components={{
        title: "My Team",
        idleIcon: <i class="i-ph:users-three" />,
        activeIcon: <i class="i-ph:users-three" />,
      }}
    >
      {/* <LockedAnchor locked={!$settings().active} /> */}
    </Anchor>
  );
}
